var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificators-form"},[_c(_vm.currentNotificatorForm,{tag:"component",attrs:{"properties":_vm.properties}}),_vm._v("\n    here somewhere\n\n    "),_c('button',{on:{"click":function($event){$event.preventDefault();_vm.saveCheck()}}},[_vm._v("Save check")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d97696d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotificatorsForm.vue
// module id = nY7n
// module chunks = 1